import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Header,
  Box,
  SpaceBetween,
  Button,
  Alert
} from '@cloudscape-design/components';

/**
 * Unauthorized page component for when users try to access resources they don't have permission for
 */
const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Box padding="l">
        <SpaceBetween size="l">
          <Header
            variant="h1"
            description="You do not have permission to view this page"
          >
            Unauthorized Access
          </Header>

          <Alert
            type="error"
            header="Access Denied"
          >
            You do not have the necessary permissions to access this resource. 
            If you believe you should have access, please contact your administrator.
          </Alert>

          <div>
            <SpaceBetween direction="horizontal" size="s">
              <Button 
                variant="primary"
                onClick={() => navigate('/dashboard')}
              >
                Go to Dashboard
              </Button>
              <Button 
                variant="link"
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>
            </SpaceBetween>
          </div>
        </SpaceBetween>
      </Box>
    </Container>
  );
};

export default Unauthorized;
